import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import AdminPreviewMode from '../../../layout/PreviewMode';
const AdminTaskPreviewPage = () => {
    const { id: rallyId, task: currentTaskNumber } = useParams();
    return (_jsx(AdminPreviewMode, { previewType: 'single-task', rallyId: rallyId, currentTaskNumber: currentTaskNumber }));
};
export default AdminTaskPreviewPage;
